import { DashboardRepliesItem } from "@/pages/Private/pages/Dashboard/schema/dashboard";

export interface PersonRowFields {
	displayName: string;
	organization: string;
	listName: string;
	updatedAtIso: string;
	listId: number;
	listPersonId: number;
}

const toIso = (value: Date | string): string => {
	if (value instanceof Date) {
		return value.toISOString();
	}

	const parsed = new Date(value);

	return Number.isNaN(parsed.getTime()) ? "" : parsed.toISOString();
};

export const personRowFields = (row: DashboardRepliesItem): PersonRowFields => {
	const first = row.prospect?.firstName?.trim();
	const last = row.prospect?.lastName?.trim();
	const prospectName = row.prospect?.name?.trim();
	const displayName = [first, last].filter(Boolean).join(" ") || prospectName || "Unknown";

	const organization = row.prospect?.organization?.name?.trim() ?? "";

	return {
		displayName,
		organization,
		listName: row.list.name,
		updatedAtIso: toIso(row.updatedAt as Date | string),
		listId: row.list.id,
		listPersonId: row.id,
	};
};

const MINUTE = 60_000;
const HOUR = 3_600_000;
const DAY = 86_400_000;

export const formatRelativeTime = (iso: string): string => {
	if (!iso) {
		return "";
	}

	const ts = new Date(iso).getTime();

	if (Number.isNaN(ts)) {
		return "";
	}

	const diff = Date.now() - ts;

	if (diff < MINUTE) {
		return "now";
	}

	if (diff < HOUR) {
		return `${Math.floor(diff / MINUTE)}m`;
	}

	if (diff < DAY) {
		return `${Math.floor(diff / HOUR)}h`;
	}

	const days = Math.floor(diff / DAY);

	if (days < 30) {
		return `${days}d`;
	}

	return new Date(iso).toLocaleDateString();
};
